import { render } from "./SpmKpi.vue?vue&type=template&id=0e285a15&scoped=true"
import script from "./SpmKpi.vue?vue&type=script&lang=ts"
export * from "./SpmKpi.vue?vue&type=script&lang=ts"

import "./SpmKpi.vue?vue&type=style&index=0&id=0e285a15&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0e285a15"

export default script